/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BulkInstallFirmwareRequest { 
    requestId?: string;
    firmwareId?: string;
    equipmentIds?: Array<string> | null;
}

